import locale from '../translations/ru.json';

const tags = [
  locale['cases.tags.item1'],
  locale['cases.tags.item2'],
  locale['cases.tags.item3'],
  locale['cases.tags.item4'],
  locale['cases.tags.item5'],
  locale['cases.tags.item6'],
  locale['cases.tags.item7'],
  locale['cases.tags.item8'],
];

const cases = {
  sber: [locale['cases.tags.item2'], locale['cases.tags.item5']],
  gazprom: [locale['cases.tags.item2'], locale['cases.tags.item5']],
  rostelecom: [locale['cases.tags.item3']],
  gals: [locale['cases.tags.item2'], locale['cases.tags.item5']],
  rzd: [locale['cases.tags.item3']],
  crafter: [locale['cases.tags.item1'], locale['cases.tags.item4']],
  ayax: [locale['cases.tags.item1'], locale['cases.tags.item4'], locale['cases.tags.item6']],
  'rzd-cu': [locale['cases.tags.item2']],
  reso: [locale['cases.tags.item1'], locale['cases.tags.item4'], locale['cases.tags.item6']],
  ranepa: [locale['cases.tags.item2'], locale['cases.tags.item5']],
  eol: [locale['cases.tags.item2'], locale['cases.tags.item5']],
  sibur: [locale['cases.tags.item6'], locale['cases.tags.item7']],
  'rml-journey': [locale['cases.tags.item3'], locale['cases.tags.item5']],
  cafeStore: [locale['cases.tags.item6'], locale['cases.tags.item7']],
  caseBspb: [locale['cases.tags.item1']],
  'sm-clinic': [locale['cases.tags.item1']],
  avatariya: [locale['cases.tags.item1'], locale['cases.tags.item6'], locale['cases.tags.item7']],
  pgufksit: [locale['cases.tags.item2'], locale['cases.tags.item5']],
  'movement-first': [locale['cases.tags.item3'], locale['cases.tags.item6'], locale['cases.tags.item8']],
  rosatom: [locale['cases.tags.item2'], locale['cases.tags.item5']],
  modis: [locale['cases.tags.item1'], locale['cases.tags.item6']],
};

document.querySelectorAll('.demonstration_section [data-animate], .footer [data-animate]').forEach((element) => {
  delete element.dataset.animateNoOffset;
  delete element.dataset.animate;
  delete element.dataset.animateDelay;
});

let tagsInnerHtml = ``;
if (tags) {
  tags.map((elem) => {
    tagsInnerHtml += `
      <div class='cases__items__inner__sticky__content__enum__elem' data-tag='${elem}'>${elem}</div>
      `;
    if (tagsInnerHtml) document.querySelector('.cases__items__inner__sticky__content__enum').innerHTML = tagsInnerHtml;
  });
}

const casesItems = document.querySelector('.cases__items');
const casesElements = Array.from(document.querySelectorAll('.cases__items__inner__blocks__elem'));
const tagsButtons = document.querySelectorAll('.cases__items__inner__sticky__content__enum__elem');
let previousTagName = '';
let isAddedTagsForCases = false;

const fadeIn = (el, timeout, display) => {
  el.style.opacity = 0;
  el.style.display = display;
  el.style.transition = `opacity ${timeout}ms`;
  setTimeout(() => {
    el.style.opacity = 1;
  }, 10);
};

const fadeOut = (el) => {
  el.style.opacity = 0;
  el.style.display = 'none';
};

const showAllCases = () => {
  for (const [caseName, tagsArray] of Object.entries(cases)) {
    const casesToShow = casesElements.filter((element) => element.dataset['case'] === caseName);
    casesToShow.forEach((element) => {
      setTimeout(() => {
        element.classList.add('active');
        fadeIn(element, 150, 'inline-flex');
      }, 1);
      if (!isAddedTagsForCases) {
        let casesTagsHtml = '';
        tagsArray.map((elem) => {
          casesTagsHtml += `
      <div class='cases__items__inner__blocks__elem__tags__item' data-tag='${elem}'>${elem}</div>
      `;
        });
        element.querySelector('.cases__items__inner__blocks__elem__tags').innerHTML = casesTagsHtml;
      }
    });
  }
  isAddedTagsForCases = true;
};

showAllCases();

const onClickTag = (event) => {
  casesElements.forEach((element) => {
    element.classList.remove('active');
    fadeOut(element);
  });
  tagsButtons.forEach((element) => element.classList.remove('active'));
  const tagName = event.currentTarget.dataset['tag'];
  if (previousTagName !== tagName) {
    previousTagName = tagName;
    event.currentTarget.classList.add('active');
    for (const [caseName, tagsArray] of Object.entries(cases)) {
      if (tagsArray.includes(tagName)) {
        const casesToShow = casesElements.filter((element) => element.dataset['case'] === caseName);
        casesToShow.forEach((element) => {
          setTimeout(() => {
            element.classList.add('active');
            fadeIn(element, 150, 'inline-flex');
          }, 1);
        });
      }
    }
  } else {
    previousTagName = '';
    showAllCases();
  }
  const y = casesItems.getBoundingClientRect().top + window.pageYOffset - 71;
  window.scrollTo({ top: y, behavior: 'smooth' });
};

const onClickTagInCases = (event) => {
  casesElements.forEach((element) => {
    element.classList.remove('active');
    fadeOut(element);
  });
  tagsButtons.forEach((element) => element.classList.remove('active'));
  const tagName = event.currentTarget.dataset['tag'];
  previousTagName = tagName;
  tagsButtons.forEach((element) => {
    if (element.dataset['tag'] === event.currentTarget.dataset['tag']) element.classList.add('active');
  });
  for (const [caseName, tagsArray] of Object.entries(cases)) {
    if (tagsArray.includes(tagName)) {
      const casesToShow = casesElements.filter((element) => element.dataset['case'] === caseName);
      casesToShow.forEach((element) => {
        setTimeout(() => {
          element.classList.add('active');
          fadeIn(element, 150, 'inline-flex');
        }, 1);
      });
    }
  }
  const y = casesItems.getBoundingClientRect().top + window.pageYOffset - 71;
  window.scrollTo({ top: y, behavior: 'smooth' });
};

const tagsButtonsInCases = document.querySelectorAll('.cases__items__inner__blocks__elem__tags__item');

tagsButtons.forEach((el) => {
  el.addEventListener('click', onClickTag);
});

tagsButtonsInCases.forEach((el) => {
  el.addEventListener('click', onClickTagInCases);
});

function slideTags() {
  if (window.matchMedia('(max-width: 1024px)').matches) {
    document.querySelector('.cases__items__inner__sticky').classList.toggle('close');
  }
}

// Trigger for sticky element
document.querySelector('.cases__items__inner__sticky__content__title').addEventListener('click', slideTags);

const stickyElm = document.querySelector('.cases__items__inner__sticky');

const observer = new IntersectionObserver(([e]) => e.target.classList.toggle('stuck', e.intersectionRatio < 1), {
  threshold: [1],
});

observer.observe(stickyElm);

// Trigger for touch devices
function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}

if (isTouchDevice()) {
  document.body.classList.add('touch');
} else {
  document.body.classList.add('no-touch');
}
